import { CUSTOM_FIELD_TYPE } from "./constants";
import { Col } from "reactstrap";
import InputField from "@components/fields/input-field";
import Select from "@components/fields/react-select/select";
import SwitchField from "@components/fields/switch-field";

const CustomFieldsRenderer = ({ fields, control, errors }) => {
    if (!fields || !fields.length) {
        return null;
    }

    const renderField = (field) => {
        const fieldKey = field.key || field.label;

        const commonProps = {
            id         : `custom_attributes_${fieldKey}`,
            name       : `custom_attributes.${fieldKey}`,
            label      : field.label,
            required   : field.required || false,
            control,
            errors,
            placeholder: field.placeholder || ""
        };
        switch (field.type) {
        case CUSTOM_FIELD_TYPE.TEXT:
            return (
                <Col lg={4} key={field._id || fieldKey}>
                    <InputField {...commonProps} type={CUSTOM_FIELD_TYPE.TEXT} />
                </Col>
            );

        case CUSTOM_FIELD_TYPE.TEXT_AREA:
            return (
                <Col lg={4} key={field._id || fieldKey}>
                    <InputField {...commonProps} type={CUSTOM_FIELD_TYPE.TEXT_AREA}/>
                </Col>
            );

        case CUSTOM_FIELD_TYPE.NUMBER:
            return (
                <Col lg={4} key={field._id || fieldKey}>
                    <InputField
                        {...commonProps}
                        type="number"
                        min={field.validation?.minVal}
                        max={field.validation?.maxVal}/>
                </Col>
            );

        case CUSTOM_FIELD_TYPE.EMAIL:
            return (
                <Col lg={4} key={field._id || fieldKey}>
                    <InputField {...commonProps} type="email" />
                </Col>
            );

        case CUSTOM_FIELD_TYPE.SELECT:
            return (
                <Col lg={4} key={field._id || fieldKey}>
                    <Select
                        {...commonProps}
                        options={field.options || []}
                        isClearable/>
                </Col>
            );

        case CUSTOM_FIELD_TYPE.CHECKBOX:
            return (
                <Col lg={4} key={field._id || fieldKey}>
                    <SwitchField {...commonProps} />
                </Col>
            );

        default:
            return null;
        }
    };

    const sortedFields = [...fields].sort(
        (a, b) => (a.order || 0) - (b.order || 0)
    );
    return sortedFields.map(renderField);
};

export default CustomFieldsRenderer;
